import { type CanvasThemeRetrieve } from '@lib/types/canvasTheme'
import type { CanvasRetrieve } from '@openapi'

export function getThemes(payload: Partial<CanvasThemeRetrieve>): Promise<CanvasThemeRetrieve[]> {
  return this.API.request('get_themes', payload)
}

export function assignCanvasTheme(payload: {
  canvas_id: CanvasRetrieve['id']
  theme_id: CanvasThemeRetrieve['id']
}): Promise<{ canvas_id: CanvasRetrieve['id']; theme_id: CanvasThemeRetrieve['id'] }> {
  return this.API.request('assign_canvas_theme', payload)
}
